module.exports = __webpack_public_path__ + "img/Icon12-15.83cc0288.svg";